const DEFAULT_API_HOST = 'https://api-prod.greensparksoftware.com'

/**
 * when deployed to AWS dev + prod environments the backend hostname will be the same for all routes
 * however, some feature deployments and backend host when working locally may be different
 * for example if I want "/core-api/..." routes to come from api.greenspark-dev.com but "/dispatch-api/..." routes to come from localhost:3001
 * I can set that up by configuring the appropriate environment variables
 * @param url
 * @return {T|string}
 */

export function getBackendHost(url) {
  if (process.env.REACT_APP_BACKEND_URL_OVERRIDE) {
    return process.env.REACT_APP_BACKEND_URL_OVERRIDE
  }
  if (url.includes('core-api') && process.env.REACT_APP_CORE_API_HOST) {
    return process.env.REACT_APP_CORE_API_HOST
  }
  if (url.includes('dispatch-api') && process.env.REACT_APP_DISPATCH_API_HOST) {
    return process.env.REACT_APP_DISPATCH_API_HOST
  }
  return DEFAULT_API_HOST
}
